import { INEC } from "../components/StudyPageTabs/Configurations/Tabs/NECs/NECs";
import { TimestampsDict } from "../store/timestampsReducer";
import { CCValidationState } from "../store/ccValidationReducer";
import { IAdditionalOutage } from "../store/additionalOutageReducer";
import { ICGMBranch } from "../store/cgmBranchesReducer";
import { ICBBranch } from "../store/cbBranchesReducer";
import { INPShift } from "../store/npShiftsReducer";
import { RAOReportState } from "../store/raoReportReducer";
import { ITask } from "./task";
import { ISubtask } from "./subtask";
import { IVerticesFiltering, VertexFilteringType } from "../store/verticesFilteringReducer";
import { LtccMonthlyYearly, LtccType, ValidationProcess } from "../store/validationProcess";
import { ITimestamp } from "../components/TimestampsSelector/timestamps";

export interface ICalculation {
    added?: string;
    started: string;
    finished?: string;
    id?: number;
    message: string;
    folderGuidString?: string;
    calculationDate: string;
    username?: string;
    calcProps?: string;
    fullyComplete?: number;
    priority: number;
    validationProcess: ValidationProcess;
    ltccType: LtccType;
    ltccMonthlyYearly: LtccMonthlyYearly;
    //timestamps: number[];
    activeTimestamps: ITimestamp[];
    tsos?: string[];
    vertices?: TimestampsDict;
    selectedVertexFilteringType: VertexFilteringType;
    necs?: INEC[];
    ccValidation?: CCValidationState;
    vertexSelection: number;
    criticalBranches: ICGMBranch[];
    npShifts: INPShift[];
    verticesLimits: IVerticesFiltering[];
    f301Necs: ICBBranch[];
    additionalOutage: IAdditionalOutage[];
    raoReport: RAOReportState;
    calculationType: number;
    fileName: string;
}

export interface ICalculationDto {
    zipFileNetworkPath: string;
    jsonString: string;
    fromTo: string;
}

export interface ITaskLogs {
    pageIndex: number;
    pageCount: number;
    totalRecordCount: number;
    numberOfPagesToShow: number;
    startPageIndex: number;
    stopPageIndex: number;
    action: string;
    capacity: number;
    defaultSortExpression?: string;
    pageParameterName: string;
    routeValue?: string;
    sortExpression?: string;
    sortExpressionParameterName: string;
    items: ITask[];
}

export interface ISubtaskLogs {
    pageIndex: number;
    pageCount: number;
    totalRecordCount: number;
    numberOfPagesToShow: number;
    startPageIndex: number;
    stopPageIndex: number;
    action: string;
    capacity: number;
    defaultSortExpression?: string;
    pageParameterName: string;
    routeValue?: string;
    sortExpression?: string;
    sortExpressionParameterName: string;
    items: ISubtask[];
}

export interface ISavedCalculation {
    userGuid: string;
    calculationParameters: string;
}

export const priorityOptions = [
    { key: 1, value: 1, text: "Low" },
    { key: 2, value: 2, text: "Medium" },
    { key: 3, value: 3, text: "High" },
];

export const validationProcessOptions = [
    { key: ValidationProcess.DayAhead, value: ValidationProcess.DayAhead, text: "DA CCV" },
    { key: ValidationProcess.IntraDay, value: ValidationProcess.IntraDay, text: "ID CCV" },
    { key: ValidationProcess.Ltcc, value: ValidationProcess.Ltcc, text: "LT CCV" },
];

export const ltccTypesOptions = [
    { key: 1, value: LtccType.Merged, text: "Merged" },
    { key: 2, value: LtccType.PerTimestamp, text: "Per timestamp" },
];
